import { Skeleton } from "@/core/components/ui/skeleton";
import { Stack } from "@/core/components/ui/stack";

export const ParticipationTrackerListItemSkeleton = ({
  widthPercentage = 0,
}: {
  widthPercentage?: number;
}) => (
  <Stack gap="xs" fullWidth>
    <Skeleton className="h-4 w-32" />
    <Stack direction="row" align="center" justify="between" fullWidth>
      <Skeleton className="h-4" style={{ width: `${widthPercentage}%` }} />
      <Skeleton className="h-4 w-10" />
    </Stack>
  </Stack>
);
